(function(){try{
  /* Case 31 - Christmas stocking gifting controller, loaded on all seven stocking product pages.
     It replaces assets/saga-multiname.js on those pages and keeps everything that file did (README
     Case 25/28): one embroidered name per personalised stocking, the two /cart/add forms trap,
     locale-safe routes, no customer-visible text in this file (all from window.SagaI18n, which
     layout/theme.liquid fills from locales/*.json), one atomic /cart/add.js request.

     GIFT OPTIONS ARE PER STOCKING. Buying four stockings does not mean four wrapped gifts, so each
     unit gets its own choice: Christmas wrapping (opt-in checkbox) and an optional handwritten card.
     One stocking gets one checkbox; several get one box per stocking, labelled with
     the embroidered name. Nothing is pre-selected: a paid extra must never be pre-ticked.

     CART CONTRACT (Case 35). Property names and values are canonical English order data; only the
     page around them is translated. The STOCKING line is self-contained for fulfilment, because the
     Shipmondo pick list prints each line's visible properties and drops keys that start with "_":
       stocking line  Stocking, Thread, Name Stocking, Gift (only when the name alone is not a unique
                      label), Gift wrapping (Yes/No), Wrapping style, Greeting card (Yes/No),
                      Card name, Card no., Card message, To, From, Greeting, _has_gpo, _saga_gift_id
       wrap line      product `wrap`, quantity 1 per wrapped stocking: For, Wrapping style,
                      _saga_gift_id, _saga_addon=wrap
       card line      product `greeting-card-handwritten-text`, quantity 1 per card: For, Card name,
                      Card no., Card message, To, From, Greeting (Case 40/43, copies of the stocking's values so the card
                      line alone tells the picker what to write), _saga_gift_id, _saga_addon=card
     Stocking and Thread come from window.SagaGift.stocking (layout/theme.liquid, keyed by handle).
     The label in Gift/For is unique across the WHOLE cart (the cart is read first), so "Holly" on a
     Tree and "Holly" on a Snowman become "Holly" and "Holly (2)", and unnamed stockings continue the
     cart's "Stocking n" numbering. A stocking with no extras gets no _saga_gift_id, so identical plain
     stockings still merge into one line. assets/saga-gift-sync.js keeps add-ons and stockings
     consistent when the cart changes afterwards. Wrapping and cards are outside the
     discount-eligible collection, so Mix & Save neither counts nor discounts them. */
  var T=window.SagaI18n,R=window.SagaRoutes||{},G=window.SagaGift;
  if(!T||!G)return;
  var EM=String.fromCharCode(8212),NS='http://www.w3.org/2000/svg',MAXQ=20;
  /* canonical order-data vocabulary (not display copy, see CART CONTRACT) */
  var DATA={christmas:'Christmas Wrapping',stocking:'Stocking ',cardHandwritten:'Handwritten',cardBlank:'Blank card \u2013 customer writes it'};
  G.cards=G.cards||[];

  /* Liquid's t filter HTML-escapes non-_html keys ("it&#39;s"); decode once, text is only ever set via textContent */
  var dec=document.createElement('textarea');
  function t(k){dec.innerHTML=String(T[k]==null?'':T[k]);return dec.value;}
  function fill(s,map){s=String(s);for(var k in map){if(Object.prototype.hasOwnProperty.call(map,k))s=s.split(k).join(map[k]);}return s;}
  function isAddForm(f){return !!f&&/[/]cart[/]add([?#]|$)/.test(f.getAttribute('action')||'');}
  function addForms(){var out=[],fs=document.querySelectorAll('form[action]'),i;for(i=0;i<fs.length;i++)if(isAddForm(fs[i]))out.push(fs[i]);return out;}
  function inAddForms(sel){var fs=addForms(),i,e;for(i=0;i<fs.length;i++){e=fs[i].querySelector(sel);if(e)return e;}return null;}
  function shopRoot(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function cartUrl(){return R.cart||(shopRoot()+'cart');}
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}
  function lines(node,text){String(text).split(/<br\s*\/?>/i).forEach(function(part,i){if(i)node.appendChild(document.createElement('br'));node.appendChild(document.createTextNode(part));});return node;}
  /* shop.money_format of the active currency, so 35 DKK reads "35 kr." on /da/ and the converted EUR price on a German visit */
  function money(cents){
    var f=G.moneyFormat||'{{amount}}',m=f.match(/\{\{\s*(\w+)\s*\}\}/);
    /* whole amounts drop their decimals, like money_without_trailing_zeros: "35 kr", not "35,00 kr" */
    function num(d,ts,ds){if(cents%100===0)d=0;var p=(cents/100).toFixed(d).split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return p[1]?p[0]+ds+p[1]:p[0];}
    if(!m)return num(2,',','.');
    var v={amount:num(2,',','.'),amount_no_decimals:num(0,',','.'),amount_with_comma_separator:num(2,'.',','),
      amount_no_decimals_with_comma_separator:num(0,'.',','),amount_with_apostrophe_separator:num(2,"'",'.'),
      amount_no_decimals_with_space_separator:num(0,' ',','),amount_with_space_separator:num(2,' ',',')}[m[1]];
    return f.replace(m[0],v==null?num(2,',','.'):v);
  }
  function icon(kind){
    var s=document.createElementNS(NS,'svg');
    s.setAttribute('viewBox','0 0 40 40');s.setAttribute('aria-hidden','true');s.setAttribute('focusable','false');
    s.setAttribute('fill','none');s.setAttribute('stroke','currentColor');s.setAttribute('stroke-width','1.4');s.setAttribute('stroke-linecap','round');s.setAttribute('stroke-linejoin','round');
    var d=kind==='card'?['M9 11h22v18H9Z','M9 11l11 9 11-9','M8 7l24 27']:['M7 14h26v19H7Z','M7 20h26','M20 14v19','M20 14c-3-6-9-6-8-2 .5 2 5 1.5 8 2Zm0 0c3-6 9-6 8-2-.5 2-5 1.5-8 2Z','M8 8l24 27'];
    d.forEach(function(p){var pa=document.createElementNS(NS,'path');pa.setAttribute('d',p);s.appendChild(pa);});
    return s;
  }
  function cardByCode(code){var i;for(i=0;i<G.cards.length;i++)if(G.cards[i].code===code)return G.cards[i];return null;}

  var form=document.querySelector('form.product-purchase-form');
  if(!isAddForm(form)){
    form=null;
    var cand=addForms(),c;
    for(c=0;c<cand.length;c++){if(cand[c].querySelector('button[type="submit"],button[name="add"]')){form=cand[c];break;}}
  }
  if(!form)return;
  var qtyInput=form.querySelector('input[name="quantity"]')||document.getElementById('quantity');
  var productId=(form.querySelector('input[name="product-id"]')||inAddForms('input[name="product-id"]')||{}).value;
  var names=[],units=[],fieldsEl=null,nameErr=null,namesWrap=null,gpoInput=null;
  var giftRoot=null,giftErr=null,sumEl=null,namesReady=!G.personalised;

  function variantId(){
    var e=form.querySelector('input[name="id"],select[name="id"]')||inAddForms('input[name="id"],select[name="id"]');
    if(e&&e.value)return Number(e.value);
    try{return Number(window.ShopifyAnalytics.meta.selectedVariantId||window.ShopifyAnalytics.meta.product.variants[0].id);}catch(x){return null;}
  }
  function optionSet(){try{var m=(window.GPOConfigs||{}).productOptionSetMap||{};return m[productId]||null;}catch(x){return null;}}
  function rawQty(){var n=parseInt(qtyInput&&qtyInput.value,10);return isNaN(n)||n<1?1:n;}
  function qty(){return Math.min(rawQty(),MAXQ);}
  function readNames(){if(!fieldsEl)return;var f=fieldsEl.querySelectorAll('.saga-mn__i'),i;for(i=0;i<f.length;i++)names[i]=f[i].value;}
  function ensureUnits(n){while(units.length<n)units.push({wrap:'none',card:'',mode:'handwritten',to:'',from:'',greeting:'',open:false});}
  function nameOf(i){return G.personalised?String(names[i]||'').trim():'';}
  function labelFor(i){return nameOf(i)||fill(t('stockingN'),{'%n':String(i+1)});}
  function hasChoice(i){var u=units[i];return !!u&&((G.wrap&&u.wrap!=='none')||(G.card&&!!u.card));}
  function anyChoice(){var n=qty(),i;for(i=0;i<n;i++)if(hasChoice(i))return true;return false;}
  function setErr(node,m){if(!node)return;node.textContent=m||'';node.hidden=!m;}

  /* ---- names: personalised stockings only, same behaviour as saga-multiname.js ---- */
  function mirror(){if(gpoInput)gpoInput.value=(names[0]||'');}
  function buildNames(){
    if(!fieldsEl)return;
    readNames();
    var n=qty(),i;
    fieldsEl.innerHTML='';
    for(i=0;i<n;i++){
      var row=el('div','saga-mn__row');
      var lab=el('label','saga-mn__l',t('nameLabel').split('%n').join(String(i+1)));lab.setAttribute('for','saga-mn-'+i);
      var inp=el('input','saga-mn__i');inp.type='text';inp.id='saga-mn-'+i;
      inp.setAttribute('maxlength','20');inp.setAttribute('autocomplete','off');inp.placeholder=t('namePlaceholder');
      inp.value=names[i]||'';
      inp.addEventListener('input',function(){readNames();setErr(nameErr,'');this.classList.remove('is-missing');mirror();refreshLabels();});
      row.appendChild(lab);row.appendChild(inp);fieldsEl.appendChild(row);
    }
    mirror();
  }
  function mountNames(input){
    gpoInput=input;
    var host=input.closest('.gpo-element')||input.parentElement;
    if(host)host.style.display='none';
    namesWrap=el('div','saga-mn');
    namesWrap.appendChild(el('p','saga-mn__help',t('nameHelp')));
    fieldsEl=el('div');
    nameErr=el('p','saga-mn__err');nameErr.setAttribute('role','alert');nameErr.hidden=true;
    namesWrap.appendChild(fieldsEl);namesWrap.appendChild(nameErr);
    if(host&&host.parentNode)host.parentNode.insertBefore(namesWrap,host.nextSibling);
    else form.insertBefore(namesWrap,form.firstChild);
    names[0]=input.value||'';
    buildNames();refreshLabels();namesReady=true;
  }

  /* ---- gift options ---- */
  function refreshLabels(){
    if(!giftRoot)return;
    var n=qty(),i;
    for(i=0;i<n;i++){
      var lab=labelFor(i);
      giftRoot.querySelectorAll('[data-who="'+i+'"]').forEach(function(e){e.textContent=lab;});
      giftRoot.querySelectorAll('[data-group-wrap="'+i+'"]').forEach(function(e){e.setAttribute('aria-label',fill(t('wrapFor'),{'%s':lab}));});
      giftRoot.querySelectorAll('[data-group-card="'+i+'"]').forEach(function(e){e.setAttribute('aria-label',fill(t('cardFor'),{'%s':lab}));});
    }
  }
  function head(sec,title,price){var h=el('div','saga-gift__head');h.appendChild(el('p','saga-gift__eye',title));if(price)h.appendChild(el('p','saga-gift__price',price));sec.appendChild(h);}
  function radio(name,value,checked){var r=el('input');r.type='radio';r.name=name;r.value=value;if(checked)r.checked=true;return r;}
  function img(src){var im=el('img');im.src=src;im.alt='';im.loading='lazy';return im;}
  /* Case 32 - gift wrapping is ONE opt-in: Christmas Wrapping only. Classic Wrapping is not offered on
     the stockings (it is untouched everywhere else). Unticked = no wrapping, the default. Every box is a
     real checkbox bound to units[i].wrap, the same state addAll() turns into cart lines: one 35 kr wrap
     line per ticked stocking. Several stockings: the main box ticks or clears all, each keeps its own. */
  function setWrap(i,on){units[i].wrap=on?'christmas':'none';}
  function checkbox(checked,onchange){var c=el('input');c.type='checkbox';c.checked=!!checked;c.addEventListener('change',function(){onchange(c.checked);});return c;}
  function wrapLabel(box){
    var lab=el('label','saga-gift__check');
    lab.appendChild(box);
    /* Case 41 - the photo leads (CSS puts it first, large and centred); the label reads without the price,
       which gets its own line underneath. Both parts still come from the one wrap_add translation. */
    var txt=t('wrapAdd'),at=txt.indexOf('%p'),pr=money(G.wrap.price).replace(/ /g,' ');
    if(at>=0)txt=(txt.slice(0,at)+txt.slice(at+2)).replace(/^[\s·:–-]+|[\s·:–-]+$/g,'');
    lab.appendChild(el('span','saga-gift__checktext',txt));
    lab.appendChild(el('span','saga-gift__checkprice',pr));
    var src=G.wrap.images&&G.wrap.images.christmas;
    if(src){var th=el('span','saga-gift__thumb');th.appendChild(img(src));lab.appendChild(th);}
    return lab;
  }
  function wrapSingle(){
    return wrapLabel(checkbox(units[0].wrap==='christmas',function(on){setWrap(0,on);updateSummary();}));
  }
  function wrapMany(n){
    var box=el('div'),list=el('div','saga-gift__picks'),ul=el('ul'),boxes=[],master,i;
    function sync(){
      var on=0,k;for(k=0;k<n;k++)if(units[k].wrap==='christmas')on++;
      master.checked=on===n;master.indeterminate=on>0&&on<n;list.hidden=on===0;
    }
    master=checkbox(false,function(on){for(var k=0;k<n;k++){setWrap(k,on);boxes[k].checked=on;}sync();updateSummary();});
    box.appendChild(wrapLabel(master));
    list.appendChild(el('p','saga-gift__hint',t('wrapLeadMany')));
    for(i=0;i<n;i++)(function(i){
      var li=el('li'),lab=el('label','saga-gift__pick'),who=el('span',null,labelFor(i));
      boxes[i]=checkbox(units[i].wrap==='christmas',function(on){setWrap(i,on);sync();updateSummary();});
      who.setAttribute('data-who',String(i));
      lab.appendChild(boxes[i]);lab.appendChild(who);li.appendChild(lab);ul.appendChild(li);
    })(i);
    list.appendChild(ul);box.appendChild(list);
    sync();
    return box;
  }
  function field(i,key,label,placeholder,tag,wide){
    var lab=el('label','saga-gift__field'+(wide?' saga-gift__field--wide':''));
    lab.appendChild(el('span',null,label));
    var inp=el(tag);
    if(tag==='input')inp.type='text';
    inp.value=units[i][key];
    inp.placeholder=placeholder;
    inp.setAttribute('maxlength',key==='greeting'?'250':'40');
    inp.setAttribute('data-'+key,String(i));
    inp.addEventListener('input',function(){units[i][key]=inp.value;inp.classList.remove('is-missing');setErr(giftErr,'');});
    lab.appendChild(inp);
    return lab;
  }
  /* Case 43 - one radio group per stocking across two galleries: the everyday cards (No card first) and,
     under their own heading, the Christmas cards (set "christmas" in window.SagaGift.cards). Both use the
     Case 42 grid. Once any card is chosen the customer says who writes it: we handwrite To/From/Greeting
     (as before) or the card comes blank. It is the same 35 kr card line either way. */
  function cardPanel(i,stepped){
    var box=el('div','saga-gift__cardpanel'),cards=el('div','saga-gift__cards'),fields=el('div','saga-gift__fields'),mode=el('div','saga-gift__mode'),wantR=null;
    fields.hidden=!units[i].card||units[i].mode==='blank';
    mode.hidden=!units[i].card;
    function gallery(list){
      var gal=el('div','saga-gift__gallery');
      gal.setAttribute('role','radiogroup');gal.setAttribute('data-group-card',String(i));gal.setAttribute('aria-label',fill(t('cardFor'),{'%s':labelFor(i)}));
      list.forEach(function(cd){
        var lab=el('label','saga-gift__tile'+(cd.code?'':' saga-gift__tile--none')),r=radio('saga-card-'+i,cd.code,units[i].card===cd.code);
        /* Case 44 - the desktop hover preview grows from the tile's own edge at the sides of the grid */
        lab.addEventListener('mouseenter',function(){var g=gal.getBoundingClientRect(),b=lab.getBoundingClientRect();lab.style.setProperty('--saga-zoom-x',b.left-g.left<8?'0%':(g.right-b.right<8?'100%':'50%'));});
        lab.appendChild(r);
        var fr=el('span','saga-gift__frame'+(cd.image?'':' saga-gift__frame--none'));
        if(cd.image)fr.appendChild(img(cd.image));else fr.appendChild(icon('card'));
        lab.appendChild(fr);
        lab.appendChild(el('span','saga-gift__tn',cd.label));
        r.addEventListener('change',function(){
          units[i].card=cd.code;mode.hidden=!cd.code;fields.hidden=!cd.code||units[i].mode==='blank';setErr(giftErr,'');
          if(stepped){units[i].want=cd.code?'yes':'no';box.setAttribute('data-want',units[i].want);if(wantR)wantR[units[i].want].checked=true;}
          var st=giftRoot.querySelector('[data-card-state="'+i+'"]');if(st)st.textContent=cd.label;
          updateSummary();
        });
        gal.appendChild(lab);
      });
      return gal;
    }
    var xmas=G.cards.filter(function(cd){return cd.set==='christmas';});
    cards.appendChild(gallery([{code:'',label:t('cardNone'),image:null}].concat(G.cards.filter(function(cd){return cd.set!=='christmas';}))));
    if(xmas.length){cards.appendChild(el('p','saga-gift__subhead',t('cardChristmasTitle')));cards.appendChild(gallery(xmas));}
    /* Case 44 - one stocking: on phones (CSS) the grids wait behind "Add a greeting card? Yes / No". No selects
       No card and keeps everything closed; Yes opens both grids. Desktop hides this step and shows the grids as
       before. Several stockings already open each card panel with their own "Choose your card" button. */
    if(stepped){
      /* a card already chosen (for example in the several-stockings view) always means Yes */
      units[i].want=units[i].card?'yes':(units[i].want==='yes'?'yes':'no');
      box.setAttribute('data-want',units[i].want);
      var want=el('div','saga-gift__want');want.appendChild(el('span','saga-gift__wantq',t('cardWant')));
      wantR={};
      [['yes',t('cardWantYes')],['no',t('cardWantNo')]].forEach(function(o){
        var lab=el('label','saga-gift__modeopt'),r=radio('saga-cardwant-'+i,o[0],units[i].want===o[0]);wantR[o[0]]=r;
        r.addEventListener('change',function(){
          units[i].want=o[0];box.setAttribute('data-want',o[0]);
          if(o[0]==='no'){var none=box.querySelector('input[name="saga-card-'+i+'"][value=""]');if(none&&!none.checked){none.checked=true;none.dispatchEvent(new Event('change'));}}
        });
        lab.appendChild(r);lab.appendChild(el('span',null,o[1]));want.appendChild(lab);
      });
      box.appendChild(want);
    }
    box.appendChild(cards);
    [['blank',t('cardWriteSelf')],['handwritten',t('cardWriteSaga')]].forEach(function(o){
      var lab=el('label','saga-gift__modeopt'),r=radio('saga-cardmode-'+i,o[0],units[i].mode===o[0]);
      r.addEventListener('change',function(){units[i].mode=o[0];fields.hidden=o[0]==='blank';setErr(giftErr,'');});
      lab.appendChild(r);lab.appendChild(el('span',null,o[1]));mode.appendChild(lab);
    });
    box.appendChild(mode);
    fields.appendChild(field(i,'to',t('cardTo'),t('cardToPlaceholder'),'input',false));
    fields.appendChild(field(i,'from',t('cardFrom'),t('cardFromPlaceholder'),'input',false));
    fields.appendChild(field(i,'greeting',t('cardGreeting'),t('cardGreetingPlaceholder'),'textarea',true));
    box.appendChild(fields);
    return box;
  }
  function cardRow(i){
    var li=el('li'),who=el('span','saga-gift__who',labelFor(i));
    who.setAttribute('data-who',String(i));li.appendChild(who);
    var cur=cardByCode(units[i].card),st=el('span','saga-gift__state',cur?cur.label:t('cardNone'));
    st.setAttribute('data-card-state',String(i));li.appendChild(st);
    var btn=el('button','saga-gift__toggle',t('cardChoose')),panel=el('div','saga-gift__panel');
    btn.type='button';panel.hidden=!units[i].open;btn.setAttribute('aria-expanded',String(!!units[i].open));
    panel.setAttribute('data-card-panel',String(i));panel.id='saga-card-panel-'+i;btn.setAttribute('aria-controls',panel.id);
    btn.addEventListener('click',function(){units[i].open=panel.hidden;panel.hidden=!units[i].open;btn.setAttribute('aria-expanded',String(units[i].open));});
    li.appendChild(btn);
    panel.appendChild(cardPanel(i));
    li.appendChild(panel);
    return li;
  }
  function renderGift(){
    if(!giftRoot)return;
    var n=qty(),i;
    ensureUnits(n);
    giftRoot.innerHTML='';
    if(G.wrap){
      var sw=el('div','saga-gift__sec');
      head(sw,t('wrapTitle'),fill(t('priceEach'),{'%p':money(G.wrap.price)}));
      sw.appendChild(lines(el('p','saga-gift__lead'),t('wrapLead')));
      sw.appendChild(n===1?wrapSingle():wrapMany(n));
      giftRoot.appendChild(sw);
    }
    if(G.card&&G.cards.length){
      var sc=el('div','saga-gift__sec');
      head(sc,t('cardTitle'),fill(t('priceEach'),{'%p':money(G.card.price)}));
      sc.appendChild(el('p','saga-gift__lead',t('cardLead')+' '+t('cardHandwritten')));
      if(n===1){sc.appendChild(cardPanel(0,true));}
      else{var ul2=el('ul','saga-gift__rows saga-gift__rows--card');for(i=0;i<n;i++)ul2.appendChild(cardRow(i));sc.appendChild(ul2);}
      var qt=G.quote&&String(G.quote.text||'').trim();
      if(qt){
        var fig=el('figure','saga-gift__quote');fig.appendChild(el('blockquote',null,qt));
        var qa=String(G.quote.author||'').trim();if(qa)fig.appendChild(el('figcaption',null,qa));
        sc.appendChild(fig);
      }
      giftRoot.appendChild(sc);
    }
    /* Case 37 - no running "Gift wrapping and cards: 70 kr" line: each section already shows its own price.
       sumEl stays null, so updateSummary() is a no-op; prices and cart lines are unaffected. */
    giftErr=el('p','saga-gift__err');giftErr.setAttribute('role','alert');giftErr.hidden=true;giftRoot.appendChild(giftErr);
    updateSummary();
  }
  function updateSummary(){
    if(!sumEl)return;
    var n=qty(),i,total=0;
    for(i=0;i<n&&i<units.length;i++){
      if(G.wrap&&units[i].wrap!=='none')total+=G.wrap.price;
      if(G.card&&units[i].card)total+=G.card.price;
    }
    sumEl.textContent=total?fill(t('summary'),{'%a':money(total)}):'';
    sumEl.hidden=!total;
  }
  /* Order on the page: names, Mix & Save, thread colour (all inside the Globo app block), then gift
     options, then Add to cart. Globo mounts its block AFTER this script has run, in the same row, so
     keep the gift block below the app block whenever that row changes. Never moves anything else. */
  function place(){
    var host=giftRoot&&giftRoot.parentNode;if(!host)return;
    var apps=host.querySelectorAll('.gpo-container'),last=apps.length?apps[apps.length-1]:null;
    while(last&&last.parentNode!==host)last=last.parentNode;
    if(last&&(giftRoot.compareDocumentPosition(last)&4))host.insertBefore(giftRoot,last.nextSibling);
  }
  function mountGift(){
    if(giftRoot||(!G.wrap&&!G.card))return;
    giftRoot=el('div','saga-gift');
    var btn=form.querySelector('button[type="submit"],button[name="add"]');
    if(btn&&btn.parentNode)btn.parentNode.insertBefore(giftRoot,btn);else form.appendChild(giftRoot);
    renderGift();
    place();
    if('MutationObserver' in window&&giftRoot.parentNode){
      var seen=0,mo=new MutationObserver(function(){if(++seen>60){mo.disconnect();return;}place();});
      mo.observe(giftRoot.parentNode,{childList:true});
      setTimeout(function(){mo.disconnect();},30000);
    }
  }

  /* ---- add to cart ---- */
  function openCart(){
    try{if(typeof window.SagaCartRefresh==='function'){if(window.SagaCartRefresh(true))return;}
        else{if(typeof window.SLIDECART_UPDATE==='function')window.SLIDECART_UPDATE();if(typeof window.SLIDECART_OPEN==='function'){window.SLIDECART_OPEN();return;}}}catch(x){}
    window.location.href=cartUrl();
  }
  function post(path,body){
    return fetch(path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body?JSON.stringify(body):undefined})
      .then(function(r){if(!r.ok)throw new Error('http '+r.status);return r.json();});
  }
  /* labels already used by gift lines in the cart, and the highest "Stocking n" */
  function usedLabels(cart){
    var used={},max=0;
    ((cart&&cart.items)||[]).forEach(function(it){
      var p=it.properties||{};
      if(!p._saga_gift_id)return;
      [p.Gift,p.For,p._saga_addon?null:p['Name Stocking']].forEach(function(v){
        if(!v)return;
        used[v]=true;
        var m=String(v).match(/^Stocking (\d+)/);if(m)max=Math.max(max,Number(m[1]));
      });
    });
    return {used:used,max:max};
  }
  function addAll(){
    readNames();
    var n=qty(),i,missing=-1,f=fieldsEl?fieldsEl.querySelectorAll('.saga-mn__i'):[],os=optionSet(),vid=variantId();
    setErr(nameErr,'');setErr(giftErr,'');
    ensureUnits(n);
    if(!vid||rawQty()>MAXQ){setErr(nameErr||giftErr,t('errorGeneric'));return;}
    if(G.personalised){
      for(i=0;i<n;i++){if(!nameOf(i)){if(missing<0)missing=i;if(f[i])f[i].classList.add('is-missing');}}
      if(missing>-1){
        setErr(nameErr,n===1?t('errorNameOne'):t('errorNames').split('%n').join(String(n)));
        if(f[missing])f[missing].focus();
        return;
      }
    }
    for(i=0;i<n;i++){
      if(G.card&&units[i].card&&units[i].mode!=='blank'&&!String(units[i].greeting).trim()){
        setErr(giftErr,fill(t('cardErrorGreeting'),{'%s':labelFor(i)}));
        var pn=giftRoot&&giftRoot.querySelector('[data-card-panel="'+i+'"]');
        if(pn&&pn.hidden){units[i].open=true;pn.hidden=false;}
        var gt=giftRoot&&giftRoot.querySelector('[data-greeting="'+i+'"]');
        if(gt){gt.classList.add('is-missing');gt.focus();}
        return;
      }
    }
    var busyEl=giftRoot||namesWrap;
    if(busyEl)busyEl.classList.add('is-busy');
    var needCart=anyChoice();
    (needCart?post(cartUrl()+'.js').catch(function(){return null;}):Promise.resolve(null)).then(function(cart){
      var u0=usedLabels(cart),used=u0.used,stamp=Date.now().toString(36),items=[];
      function unique(base){var l=base,k=2;while(used[l]){l=base+' ('+k+')';k++;}used[l]=true;return l;}
      for(i=0;i<n;i++){
        var u=units[i],nm=nameOf(i),props={},gid='',lab='';
        var hasWrap=!!(G.wrap&&DATA[u.wrap]&&u.wrap!=='stocking'),card=G.card&&u.card?cardByCode(u.card):null;
        if(hasWrap||card){lab=unique(nm||(DATA.stocking+(u0.max+i+1)));gid='g'+stamp+'-'+i;}
        /* Case 35 - the stocking line is the complete, self-contained fulfilment block: visible
           properties in packing order, hidden keys last (Shipmondo drops keys starting with "_"). */
        if(G.stocking&&G.stocking.design)props['Stocking']=G.stocking.design;
        if(G.stocking&&G.stocking.thread)props['Thread']=G.stocking.thread;
        if(G.personalised)props['Name Stocking']=nm;
        if(lab&&lab!==nm)props['Gift']=lab;
        if(G.wrap){props['Gift wrapping']=hasWrap?'Yes':'No';if(hasWrap)props['Wrapping style']=DATA[u.wrap];}
        if(G.card)props['Greeting card']=card?'Yes':'No';
        if(card){
          props['Card name']=card.name;
          props['Card no.']=card.code;
          /* Case 43 - who writes the card, spelled out for the warehouse; a blank card has no To/From/Greeting */
          props['Card message']=u.mode==='blank'?DATA.cardBlank:DATA.cardHandwritten;
          if(u.mode!=='blank'){
            if(String(u.to).trim())props['To']=String(u.to).trim();
            if(String(u.from).trim())props['From']=String(u.from).trim();
            props['Greeting']=String(u.greeting).trim();
          }
        }
        if(os)props['_has_gpo']=String(os);
        if(gid)props['_saga_gift_id']=gid;
        items.push({id:vid,quantity:1,properties:props});
        /* paid add-on lines: pricing and picking only, tied to their stocking by the visible For label */
        if(hasWrap)items.push({id:(DATA[u.wrap]==='Christmas Wrapping'&&G.wrap.variantChristmas)?G.wrap.variantChristmas:G.wrap.variant,quantity:1,properties:{'For':lab,'Wrapping style':DATA[u.wrap],'_saga_gift_id':gid,'_saga_addon':'wrap'}});
        if(card){
          /* Case 40 - the card line also carries the message to handwrite (the same values as the stocking
             line above), so the picker can read the card line alone; hidden keys stay last */
          var cp={'For':lab,'Card name':card.name,'Card no.':card.code};
          ['Card message','To','From','Greeting'].forEach(function(k){if(props[k])cp[k]=props[k];});
          cp._saga_gift_id=gid;cp._saga_addon='card';
          items.push({id:G.card.variant,quantity:1,properties:cp});
        }
      }
      return post(R.cartAdd?R.cartAdd+'.js':shopRoot()+'cart/add.js',{items:items});
    })
      .then(function(){if(busyEl)busyEl.classList.remove('is-busy');if(typeof window.SagaCartCount==='function')window.SagaCartCount();openCart();})
      .catch(function(){if(busyEl)busyEl.classList.remove('is-busy');setErr(giftErr||nameErr,t('errorAdd'));});
  }

  /* Capture phase on DOCUMENT beats any handler bound on the form, the button, Globo or GiftLab.
     An un-personalised stocking with no gift choice is left to the theme's own add to cart. */
  function ready(){return namesReady&&(!!giftRoot||(!G.wrap&&!G.card));}
  function take(){return ready()&&(G.personalised||anyChoice());}
  document.addEventListener('click',function(e){
    var tg=e.target;if(!tg||!tg.closest)return;
    var btn=tg.closest('button[type="submit"],input[type="submit"],button[name="add"]');
    if(!btn||!form.contains(btn)||!take())return;
    e.preventDefault();e.stopImmediatePropagation();addAll();
  },true);
  document.addEventListener('submit',function(e){
    if(e.target!==form||!take())return;
    e.preventDefault();e.stopImmediatePropagation();addAll();
  },true);

  function onQty(){buildNames();renderGift();refreshLabels();}
  if(qtyInput){
    qtyInput.addEventListener('input',onQty);
    qtyInput.addEventListener('change',onQty);
    var last=qtyInput.value;
    setInterval(function(){if(qtyInput.value!==last){last=qtyInput.value;onQty();}},400);
  }
  mountGift();
  if(G.personalised){
    /* the app renders asynchronously, so wait for its name field rather than assuming it is there */
    var tries=0,timer=setInterval(function(){
      var input=document.getElementById('text-1');
      if(input){clearInterval(timer);mountNames(input);}
      else if(++tries>80)clearInterval(timer);
    },250);
  }
}catch(e){}})();
